<template>
	<div class="row margin-b20 center-xs center-md center-lg pt-4">
		<div class="loader"></div>
	</div>
</template>
